
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.664 3.434h-1.312v-.757A.687.687 0 0017.656 2a.686.686 0 00-.697.677v.757H7.328v-.757A.686.686 0 006.63 2a.686.686 0 00-.697.677v.757H4.336C3.05 3.434 2 4.44 2 5.692V17.73C2 18.98 3.045 20 4.336 20h15.328C20.95 20 22 18.98 22 17.73V5.692c0-1.25-1.045-2.258-2.336-2.258zm.943 14.296a.93.93 0 01-.943.916H4.336a.93.93 0 01-.943-.916V9.128h17.214v8.602zM3.393 7.774V5.692c0-.506.423-.904.943-.904h1.598v.505c0 .375.312.677.697.677a.686.686 0 00.697-.677v-.505h9.631v.505c0 .375.311.677.697.677a.687.687 0 00.697-.677v-.505h1.31c.521 0 .944.398.944.904v2.082H3.393z","fill":"currentColor"}})])
          )
        }
      }
    